define('views/blocks/OptinRgpdView',['underscore', 'backbone', 'jquery', 'app', 'SubView',
        'template!blocks/account/optin-rgpd',
        'InputView',
        'InputPhoneView',
        'moment',
        'phoneUtils'],

function (_, Backbone, $, app, SubView,
        optinRgpdTemplate,
        InputView,
        InputPhoneView,
        moment,
        phoneUtils
            ) {

    return Backbone.View.extend(SubView).extend({
        events:{
            'click .btn-close':'cancel',
            'click .btn-classic':'submit'
        },

        initialize:function(options){
            var view = this;
            view.subviews = [];
            view.render();
            view.attachViews(InputPhoneView.initializeInputsOfView(view));
            view.attachViews(InputView.initializeInputsOfView(view));
        },

        updateCountryCode:function(code){
            var view = this;
            if(!code || code.length === 0){
                code = 'FR';
            }
            view.code = code;
            var prefix = phoneUtils.getCodeForRegion(code);
            view.$('.input-phone__regions-preview').html('<div class="flag-icon flag-icon-'+code.toLowerCase()+'"></div><span class="phone-prefix">(+'+prefix+')</span>');
            view.updateInput();
        },

        render:function(){
            var view = this;
            view.$el.html(optinRgpdTemplate({'customer': app.getCustomer()}));
        },

        cancel:function(){
            app.trigger('cancelOptinRgpd');
            this.close();
        },

        close:function(){
            this.trigger('close', this);
        },
        submit: function(e) {
            e.preventDefault();
            var view = this,
                banNotice = false,
                form = view.$('.form-infos'),
                datas = {},
                customer = app.getCustomer();

            //
            // sauvegarde les données client
            //
            form.serializeArray().forEach(function (o) {
                datas[o.name] = o.value
            });

            var datasTmp = _(datas).pick(
                'id_gender',
                'phone',
                'birthday',
                'firstname',
                'lastname',
                'optin',
                'sms',
                'mail_alert'
            );
            datas = datasTmp;

            var requireFields = customer.requireFields(),
                requireOptin = customer.requireOptin();

            if(requireFields) {
                // récupère le champs téléphone au format E164 et le valide.
                datas.phone = phoneUtils.validate(view.$('input[name="phone"]').data('E164'));

                var birthDay = moment(datas.birthday, 'DD/MM/YYYY'), now = moment();
                datas.birthday = birthDay.format('YYYY-MM-DD');
            }

            if (requireFields && !datas.id_gender) {
                banNotice = 'Merci de rentrer votre civilité';
            }else if (requireFields && !datas.firstname) {
                banNotice = 'Merci de rentrer un prénom valide';
            }else if (requireFields && !datas.lastname) {
                banNotice = 'Merci de rentrer un nom valide';
            }else if(requireFields && !datas.phone){
                banNotice = 'Merci de rentrer un numeros de téléphone valide';
            }else if (requireFields && !birthDay.isValid()) {
                banNotice = 'Merci de rentrer une date de naissance valide';
            } else if (requireFields && now.diff(birthDay, 'years') > 130) {
                banNotice = 'Merci de rentrer une date de naissance valide';
            } else if (requireFields && now.diff(birthDay, 'years') < parseInt(app.c('_MIN_YEAR_FORBIDDEN_', 18))) {
                banNotice = 'Vous n\'avez pas l\'âge minimum requis';
            }else if (requireOptin && !datas.optin) {
                banNotice = "Merci d’accepter les conditions";
            }
            if(banNotice) {
                return app.banNotice(app.t(banNotice, 'Account'));
            }
            view.$(':submit').toggleClass('loading').attr('disabled',true);

            customer.save(datas).done(function(){
                view.close()
            }).fail(function(){
                app.alert();
            })

        }
    });
});


